var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOogwaiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_2727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 40.75C24.2843 40.75 31 34.0343 31 25.75C31 17.4657 24.2843 10.75 16 10.75C7.71573 10.75 1 17.4657 1 25.75C1 34.0343 7.71573 40.75 16 40.75Z",
    fill: "white",
    stroke: "#609F81",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6186 39.132C10.8364 40.0004 9.64874 40.867 8.88996 40.04L8.89719 40.0328C3.12911 34.8524 -0.268469 27.0444 10.1199 25.22C11.2576 24.9139 13.2561 24.8544 15.5066 24.7874C22.0789 24.5917 30.8006 24.3321 26.5099 17.68C25.4599 16.09 24.0299 14.61 22.5599 13.35C21.5878 12.5154 22.814 11.0348 23.8053 11.7861C25.4673 12.4398 27.8068 15.1352 28.33 15.84C32.59 21.27 32.97 29.2 25.3 31.57C22.9434 32.4044 20.4871 32.4716 18.0424 32.5385C15.6526 32.6039 13.2739 32.669 11.01 33.45C7.98785 34.4442 8.55121 36.6595 10.2866 38.5981C10.2944 38.6054 10.3021 38.6127 10.3099 38.62C10.4814 38.7772 10.5791 38.9534 10.6186 39.132ZM29.2831 22.6722C29.4656 24.0553 29.3033 25.4434 28.67 26.74C26.2774 30.3034 21.9703 30.424 17.8257 30.5399C16.2711 30.5835 14.7393 30.6263 13.34 30.85C9.96977 31.2139 7.47486 32.6665 6.944 34.8195C4.66487 31.5138 4.2933 28.1604 10.4799 27.19C12.5045 26.8252 14.5821 26.7786 16.6631 26.7319C19.7729 26.6622 22.8904 26.5923 25.8499 25.46C27.6902 24.7481 28.767 23.7794 29.2831 22.6722Z",
    fill: "#609F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67 26.74C29.3033 25.4434 29.4656 24.0553 29.2831 22.6722C28.767 23.7794 27.6902 24.7481 25.8499 25.46C22.8904 26.5923 19.7729 26.6622 16.6631 26.7319C14.5821 26.7786 12.5045 26.8252 10.4799 27.19C4.2933 28.1604 4.66487 31.5138 6.944 34.8195C7.47486 32.6665 9.96977 31.2139 13.34 30.85C14.7393 30.6263 16.2711 30.5835 17.8257 30.5399C21.9703 30.424 26.2774 30.3034 28.67 26.74Z",
    fill: "#A2D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0101 14.42C19.2686 14.42 21.9101 11.774 21.9101 8.51001C21.9101 5.246 19.2686 2.60001 16.0101 2.60001C12.7516 2.60001 10.1101 5.246 10.1101 8.51001C10.1101 11.774 12.7516 14.42 16.0101 14.42Z",
    fill: "white",
    stroke: "#609F81",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.55 9.74C23.55 10.63 22.83 11.34 21.95 11.34C21.71 11.34 21.48 11.29 21.27 11.19C21.68 10.38 21.91 9.47 21.91 8.5C21.91 8.38 21.91 8.25 21.9 8.13C21.92 8.13 21.93 8.13 21.95 8.13C22.84 8.13 23.55 8.85 23.55 9.73V9.74Z",
    fill: "#A2D7BE",
    stroke: "#609F81",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.77 11.22C10.58 11.3 10.37 11.34 10.15 11.34C9.27005 11.34 8.55005 10.62 8.55005 9.74001C8.55005 8.86001 9.25005 8.15001 10.13 8.14001C10.13 8.26001 10.12 8.39002 10.12 8.51002C10.12 9.49002 10.36 10.41 10.78 11.22H10.77Z",
    fill: "#A2D7BE",
    stroke: "#609F81",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.01 2.6C17 2.6 17.92 2.84 18.74 3.27C18.61 1.86 17.43 0.75 15.98 0.75C14.53 0.75 13.34 1.87 13.22 3.3C14.05 2.85 15 2.6 16.01 2.6Z",
    fill: "#A2D7BE",
    stroke: "#609F81",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2601 11.23C21.2601 11.23 22.1201 6.82999 18.7301 6.82999C16.7801 6.82999 17.0001 8.96999 17.0001 8.96999L19.2101 8.98999",
    stroke: "#609F81",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8001 11.23C10.8001 11.23 9.84006 6.78 13.2201 6.78C15.1701 6.78 14.9501 8.92 14.9501 8.92L12.7401 8.94",
    stroke: "#609F81",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.01 23.25C21.08 18.99 23.4 10.41 18.8 10.41C16.24 10.41 16.03 12.36 16.03 12.36C16.03 12.36 15.34 10.41 12.75 10.41C8.69 10.41 11.81 19.05 16.01 23.25Z",
    fill: "white",
    stroke: "#609F81",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 15.03C19.32 13.39 17.58 12.36 16.04 12.36C14.6 12.36 12.76 13.49 12.76 14.93C12.76 17.4 14.61 23.25 16.02 23.25C17.43 23.25 19.33 18.83 19.33 15.03H19.32Z",
    fill: "#A2D7BE",
    stroke: "#609F81",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1393 23.2374L16.1391 23.2374L16.1433 23.2508C16.1551 23.2879 16.1543 23.3094 16.1533 23.3183C16.1523 23.3272 16.1499 23.3337 16.1458 23.3403C16.136 23.3563 16.108 23.3839 16.057 23.3995C16.0061 23.4152 15.9664 23.4083 15.948 23.4001C15.9403 23.3966 15.9342 23.3923 15.9282 23.3854C15.9234 23.3798 15.9144 23.3678 15.9053 23.3447C15.8119 22.837 15.6728 22.0365 15.5322 21.1947C15.584 21.3677 15.6353 21.5383 15.6857 21.7059C15.8527 22.2615 16.0092 22.7823 16.1393 23.2374Z",
    fill: "#609F81",
    stroke: "#609F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8776 23.238L15.8805 23.2384C16.0254 22.7348 16.2052 22.1531 16.3969 21.5331C16.4272 21.4348 16.4579 21.3357 16.4887 21.2357C16.4782 21.2926 16.4677 21.3494 16.4573 21.406C16.3333 22.0776 16.2139 22.7242 16.1182 23.3094C16.1095 23.3492 16.0978 23.3689 16.092 23.3769C16.0861 23.3852 16.0806 23.3896 16.0742 23.393C16.0586 23.4015 16.0202 23.4115 15.9673 23.398C15.9144 23.3845 15.8851 23.3573 15.8749 23.3417C15.8708 23.3353 15.8678 23.3283 15.8665 23.3176C15.8651 23.3067 15.8642 23.2813 15.8776 23.238Z",
    fill: "#609F81",
    stroke: "#609F81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_2727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 41.5,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOogwaiLogo);
export default __webpack_public_path__ + "static/media/Oogwai-logo.c838846ac2c484fd3465208f9e11c54a.svg";
export { ForwardRef as ReactComponent };